export const dataroomProviderCollection = [
  {
    value: 'DebtDomain',
    label: 'DebtDomain',
  },
  {
    value: 'Intralinks',
    label: 'Intralinks',
  },
  {
    value: 'StructuredFN',
    label: 'StructuredFN',
  },
  {
    value: 'Trustee',
    label: 'Trustee',
  },
  {
    value: 'Other',
    label: 'Other',
  },
];
